import {
  RslColumnChartProps,
  rslColumnChartOptions,
} from '../../configuration/columnChartOptions';
import { Stack } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartTitle } from './ChartTitle';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

type ColumnChartWithHeaderProps = {
  title: string;
  chartProps: RslColumnChartProps;
};

export const ColumnChartWithHeader = (props: ColumnChartWithHeaderProps) => {
  return (
    <Stack
      direction="column"
      gap="1rem"
      border={1}
      borderColor={unifiedPlatformColorPalette.lightGrey300}
      borderRadius="4px"
      sx={{ p: 2 }}
    >
      <ChartTitle title={props.title} />
      <HighchartsReact
        highcharts={Highcharts}
        options={rslColumnChartOptions(props.chartProps)}
      />
    </Stack>
  );
};
